module.exports = __webpack_public_path__ + "img/lasource-24.be3e2d44.jpg";